var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workben_main"},[_c('workben-nav'),_c('workben-works'),_c('workben-property')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }